<template>
  <div class="bg-main">
    <div class="header-bg">
      <el-container class="mh-less">
        <Header />
      </el-container>
    </div>

    <Home />
    <el-container class="mh-less">
      <Register />
    </el-container>
    <!-- <Accommodation /> -->
    <el-container class="mh-less">
      <Schedule />
    </el-container>
    <el-container class="mh-less">
      <ContactUs />
    </el-container>

    <Footer />
  </div>
</template>

<script>
import Header from "@/layout/Header";
import Footer from "@/layout/Footer";

import Home from "@/components/home/Home";
import Register from "@/components/home/Register";
// import Accommodation from "@/components/home/Accommodation";
import Schedule from "@/components/home/Schedule";
import ContactUs from "@/components/home/ContactUs";

export default {
  name: "HomePage",
  components: {
    Header,
    Footer,
    Home,
    Register,
    // Accommodation,
    Schedule,
    ContactUs,
  },
  props: {
    msg: String,
  },
};
</script>
